import React from 'react';
import { CtaLink } from './ui';
import { whatsappUrl } from '../../data/links';
import { IMAGES } from '../../data/vcars';
export function Hero() {
  return <section id="top" className="relative overflow-hidden" data-id="element-38" data-mp="2sbqfnepnknf6">
      <img src={IMAGES.hero} alt="Auto moderno exhibido en una concesionaria" className="absolute inset-0 h-full w-full object-cover" data-id="element-39" data-mp="2nhman0zy6pgq" />
      <div className="absolute inset-0 bg-[#08090b]/85" data-id="element-40" data-mp="2dkhoh163qtzx" />

      <div className="relative mx-auto w-full max-w-6xl px-5 py-16 sm:px-8 sm:py-24 lg:px-12 lg:py-32" data-id="element-41" data-mp="2dm2hungok6w7">
        <div className="max-w-3xl" data-id="element-42" data-mp="29l8sdpnlak17">
          <h1 className="font-display text-[2rem] font-bold uppercase leading-[1.02] text-white sm:text-5xl lg:text-6xl" data-id="element-43" data-mp="24jjf03cw9u9y">
            Conseguí tu próximo auto sin perder tiempo, sin vueltas y con{' '}
            <span className="text-[#5b83ff]" data-id="element-44" data-mp="2t7yslkv87e3">asesoramiento real</span>
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/70 sm:mt-7 sm:text-xl" data-id="element-45" data-mp="3tyzlfazfp1w5">
            En VCARS te ayudamos a encontrar, comparar, financiar y reservar el
            vehículo ideal según tu presupuesto. También podés entregar tu usado
            en parte de pago.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-46" data-mp="bwwopm8gf3e7">
            <CtaLink href={whatsappUrl('Hola VCARS, quiero que me asesoren para comprar o cambiar mi auto.')} label="Quiero que me asesoren por WhatsApp" data-id="element-47" data-mp="byzkkmwafqqu" />
            <CtaLink href="#como-funciona" label="Ver cómo funciona" variant="ghost" withIcon={false} data-id="element-48" data-mp="19kx3glekxy3b" />
          </div>

          <p className="mt-5 text-xs uppercase tracking-[0.18em] text-white/45 sm:text-sm" data-id="element-49" data-mp="zuc611an6zlz">
            Respuesta rápida · Atención personalizada · Opciones según
            disponibilidad
          </p>
        </div>
      </div>
    </section>;
}